import Select from './select';
import Option from './option';
import OptionGroup from './option-group';
import Loading from '../loading';

Select.install = function(Vue) {
  Vue.component(Select.name, Select);
  Vue.component(Option.name, Option);
  Vue.component(OptionGroup.name, OptionGroup);
  Vue.use(Loading);
};

export default Select;
